// @flow

import React, { Component } from 'react';
import { Badge, Button, Link, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ExternalMinor } from '@shopify/polaris-icons';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { getAssetURL } from 'src/helpers';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';

type Props = {
  index: number,
  icon: number,
  name: number,
  appListingURL: string,
  description: string,
  instructionURL: string
};

type ComposedProps = Props & WithI18nProps;

type State = {};

class KlaviyoCard extends Component<ComposedProps, State> {
  handleToKlaviyoIntegration = () => {
    history.push(routes.integration.klaviyo.view());
  };

  render() {
    const { i18n, data = {}, index } = this.props;
    const { icon, name, appListingURL, description, instructionURL, isFeaturingPartner } = data;

    return (
      <div className={index === 1 ? 'item middle' : 'item'}>
        <div className="item-header">
          <a
            className="Polaris-Link"
            href={appListingURL}
            target="_blank"
            rel="noopener noreferrer">
            <img
              className="icon"
              src={icon}
              alt={i18n.translate(name)}
              style={{ boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.07)' }}
            />
          </a>
          {isFeaturingPartner && (
            <div className="integration integration--partner">
              <Badge status="info">
                <img
                  className="IconChecked"
                  src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.iconCheckPink)}
                  alt="IconChecked"
                  width={14}
                  height={14}
                />

                {i18n.translate('AdminHTML.Integration.Integration.featuringPartner')}
              </Badge>
            </div>
          )}
        </div>

        {/* App name */}
        <p className="name">{i18n.translate(name)}</p>

        {/* App description */}
        <p className="description">{i18n.translate(description)}</p>

        <div className="BC-Checkbox-Status__Wrapper">
          <div className="integration">
            <Badge status="info">
              <Link url={instructionURL} external>
                {i18n.translate('AdminHTML.Integration.Constants.integrationGuide')}
                <Icon source={ExternalMinor} />
              </Link>
            </Badge>
          </div>

          <div className="btn-configure">
            <Button onClick={this.handleToKlaviyoIntegration}>
              {i18n.translate('AdminHTML.Integration.Integration.configure')}
            </Button>
          </div>
        </div>

        {/* App instruction */}
        {/* <div className="instruction">
          {i18n.translate('AdminHTML.Integration.Integration.instruction', {
            t: (
              <Link external url={instructionURL}>
                {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                  nt_name: i18n.translate(name)
                })}
              </Link>
            )
          })}
        </div> */}
      </div>
    );
  }
}

export default withI18n()(KlaviyoCard);
